import RFB from '@novnc/novnc/core/rfb.js';
$(function () {
    // Store the current RFB instance globally for button actions
    let currentRfb = null;

    function updateConnectionStatus(status, message) {
        const statusElement = $('.connection-status');

        if (status === 'connected') {
            statusElement.removeClass('bg-warning bg-danger').addClass('bg-success');
            statusElement.text(message || 'Connected');
            $('.console-controls button').prop('disabled', false);
        } else if (status === 'connecting') {
            statusElement.removeClass('bg-success bg-danger').addClass('bg-warning');
            statusElement.text(message || 'Connecting...');
            $('.console-controls button').prop('disabled', true);
        } else if (status === 'disconnected') {
            statusElement.removeClass('bg-success bg-warning').addClass('bg-danger');
            statusElement.text(message || 'Disconnected');
            $('.console-controls button').prop('disabled', true);
        }
    }

    function connect(self) {
        updateConnectionStatus('connecting');

        // Disconnect existing connection if any
        if (currentRfb) {
            try {
                currentRfb.disconnect();
                currentRfb = null;
            } catch (e) {
                console.error('Error disconnecting:', e);
            }
        }

        var connectDetailUrl = self.data('vnc-console');
        $.post(connectDetailUrl, function (res) {
            if (res.success) {
                const rfb = new RFB(self[0], res.endpoint, {
                    credentials: {
                        password: res.password
                    },
                    resizeSession: true,
                    qualityLevel: 6,
                    compressionLevel: 2
                });

                // Store the RFB instance globally
                currentRfb = rfb;

                rfb.focusOnClick = true;
                rfb.scaleViewport = true;
                rfb.clipViewport = true;

                // Handle window resize to adjust the console
                const resizeObserver = new ResizeObserver(() => {
                    if (rfb._display) {
                        rfb.scaleViewport = true;
                    }
                });
                resizeObserver.observe(self[0]);

                // Event listeners for connection status
                rfb.addEventListener("connect", function () {
                    updateConnectionStatus('connected');
                });

                rfb.addEventListener("disconnect", function () {
                    updateConnectionStatus('disconnected');
                    currentRfb = null;
                    setTimeout(function () {
                        connect(self);
                    }, 3000);
                });

                rfb.addEventListener("credentialsrequired", function () {
                    updateConnectionStatus('connecting', 'Authentication required...');
                });
            } else {
                updateConnectionStatus('disconnected', 'Connection failed');
                setTimeout(function () {
                    connect(self);
                }, 5000);
            }
        }, "json").fail(function() {
            updateConnectionStatus('disconnected', 'Connection failed');
            setTimeout(function () {
                connect(self);
            }, 5000);
        });
    }

    // Initialize console
    $('[data-vnc-console]').each(function () {
        const self = $(this);
        connect(self);
    });

    // Handle control buttons
    $('#sendCtrlAltDel').on('click', function() {
        if (currentRfb && currentRfb._rfb_connection_state === 'connected') {
            currentRfb.sendCtrlAltDel();
        }
    });

    $('#reconnectConsole').on('click', function() {
        const consoleElement = $('[data-vnc-console]');
        if (consoleElement.length) {
            connect(consoleElement);
        }
    });

    // Toggle fullscreen
    $('#toggleFullscreen').on('click', function() {
        const consoleContainer = $('.console-container')[0];

        if (!document.fullscreenElement) {
            if (consoleContainer.requestFullscreen) {
                consoleContainer.requestFullscreen();
            } else if (consoleContainer.webkitRequestFullscreen) {
                consoleContainer.webkitRequestFullscreen();
            } else if (consoleContainer.msRequestFullscreen) {
                consoleContainer.msRequestFullscreen();
            }
            $(this).find('i').removeClass('fa-expand').addClass('fa-compress');
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            $(this).find('i').removeClass('fa-compress').addClass('fa-expand');
        }
    });

    // Handle fullscreen change event
    $(document).on('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange', function() {
        if (!document.fullscreenElement) {
            $('#toggleFullscreen').find('i').removeClass('fa-compress').addClass('fa-expand');
        }
    });
})
